import React, { useState, useEffect } from 'react';
import Footer from '../components/Footer';
import '../styles/Home.css';
import { useNavigate } from 'react-router-dom';

const Home = () => {
  const navigate = useNavigate();
  // Fixed Video Background Component
  const FixedVideoBackground = () => {
    useEffect(() => {
      // Create animated particles
      const createParticles = () => {
        const particlesContainer = document.getElementById('particles');
        if (!particlesContainer) return;

        // Clear existing particles
        particlesContainer.innerHTML = '';

        // Create particles
        for (let i = 0; i < 50; i++) {
          const particle = document.createElement('div');
          particle.className = 'particle';
          particle.style.cssText = `
            position: absolute;
            width: ${Math.random() * 4 + 1}px;
            height: ${Math.random() * 4 + 1}px;
            background: rgba(255, 255, 255, ${Math.random() * 0.5 + 0.1});
            border-radius: 50%;
            left: ${Math.random() * 100}%;
            top: ${Math.random() * 100}%;
            animation: float ${Math.random() * 10 + 5}s infinite linear;
            animation-delay: ${Math.random() * 5}s;
          `;
          particlesContainer.appendChild(particle);
        }
      };

      createParticles();
    }, []);

    return (
      <div className="fixed-video-background">
        {/* Video Background */}
        <video autoPlay muted loop playsInline className="fixed-hero-video">
          <source src="/assets/hero section videos/herosection1.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>

        {/* Overlay */}
        <div className="fixed-hero-overlay"></div>

        {/* Animated Particles */}
        <div className="fixed-hero-particles" id="particles"></div>
      </div>
    );
  };

  // Hero Section Component
  const HeroSection = () => {
    return (
      <div className="home-hero-section">
        {/* Hero Content */}
        <div className="home-hero-content">
          <div className="home-hero-title-container">
            <h1 className="home-hero-title">Films with Passion...</h1>
          </div>
        </div>
      </div>
    );
  };

  // Services Section Component
  const ServicesSection = () => {
    const services = [
      {
        id: 'future-films',
        title: 'Future Films',
        icon: (
          <img src="/assets/ads_icons/celebrity-ads.png" alt="Future Films" />
        )
      },
      {
        id: 'concept-ads',
        title: 'Concept Ads',
        icon: (
          <img src="/assets/ads_icons/concept-ads.png" alt="Concept Ads" />
        )
      },
      {
        id: 'commercials',
        title: 'Commercials',
        icon: (
          <img src="/assets/ads_icons/commercials-ads.png" alt="Concept Ads" />
        )
      },
      {
        id: 'corporates',
        title: 'Corporates',
        icon:(
          <img src="/assets/ads_icons/corporates-ads.png" alt="Concept Ads" />
        )
        
      },
      {
        id: 'digital-ads',
        title: 'Digital Ads',
        icon: (
          <img src="/assets/ads_icons/digital-ads.png" alt="Concept Ads" />
        )
      },
      {
        id: 'theater-ads',
        title: 'Theater Ads',
        icon: (
         <img src="/assets/ads_icons/theater-ads.png" alt="Concept Ads" />
        )
      },
      {
        id: 'tv-ads',
        title: 'TV Ads',
        icon: (
          <img src="/assets/ads_icons/tv-ads.png" alt="Concept Ads" />
        )
      },
      {
        id: 'Influencer-ads',
        title: 'Influencer Ads',
        icon: (
          <img src="/assets/ads_icons/influencer-ads.png" alt="Concept Ads" />
        )
      },
    ];

    const handleServiceClick = (serviceId) => {
      // Client-side navigate to Services with hash
      navigate(`/services#${serviceId}`);
    };

    return (
      <section className="home-services-section">
        <div className="home-services-container">
          <div className="home-services-header">
            <h2 className="home-services-title">
              <span className="home-title-accent">Services</span> We Offer
            </h2>
            <p className="home-services-subtitle">
              Comprehensive advertising solutions tailored to elevate your brand
            </p>
          </div>
          
          <div className="home-services-grid">
            {services.map((service, index) => (
              <div 
                key={service.id} 
                className="home-service-card"
                onClick={() => handleServiceClick(service.id)}
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="home-service-icon">
                  {service.icon}
                </div>
                <h3 className="home-service-title">{service.title}</h3>
                <p className="home-service-description">
                  Professional {service.title.toLowerCase()} solutions designed to maximize your reach and impact.
                </p>
                <button 
                  className="home-service-btn"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleServiceClick(service.id);
                  }}
                >
                  Learn More
                  <svg className="home-service-btn-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M5 12h14" />
                    <path d="M12 5l7 7-7 7" />
                  </svg>
                </button>
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  };

  // Film Making Section Component
  const FilmMakingSection = () => {
    const [currentSlide, setCurrentSlide] = useState(0);
    
    const images = [
      '/assets/film_making/film-making01.jpg',
      '/assets/film_making/film-making02.jpg',
      '/assets/film_making/film-making03.jpg',
      '/assets/film_making/film-making04.jpg',
      '/assets/film_making/film-making05.jpg'
    ];

    useEffect(() => {
      const interval = setInterval(() => {
        setCurrentSlide((prev) => (prev + 1) % images.length);
      }, 5000);

      return () => clearInterval(interval);
    }, [images.length]);

    const nextSlide = () => {
      setCurrentSlide((prev) => (prev + 1) % images.length);
    };

    const prevSlide = () => {
      setCurrentSlide((prev) => (prev === 0 ? images.length - 1 : prev - 1));
    };

    const goToSlide = (index) => {
      setCurrentSlide(index);
    };

    return (
      <div className="home-film-making-section">
        <h2 className="home-film-making-title">Film Making</h2>
        <div className="home-film-making-underline"></div>
        <p className="home-film-making-description">
          We are trusted experts in delivering high-quality and dependable ad film production services across various industries. Our ad films are designed to capture attention and boost brand awareness. Each project highlights your core business values while building a strong emotional bond with your audience. We also match your brand with the right celebrity endorsements to maximize engagement. Offering end-to-end film production solutions, we showcase your brand with cinematic impact and creative excellence.
        </p>
        
        <div className="home-film-carousel-container">
          <div className="home-film-carousel">
            <div className="home-film-carousel-track" style={{ transform: `translateX(-${currentSlide * 100}%)` }}>
              {images.map((image, index) => (
                <div key={index} className={`home-film-carousel-slide ${index === currentSlide ? 'active' : ''}`}>
                  <img src={image} alt={`Film Making ${index + 1}`} />
                </div>
              ))}
            </div>
            
            {/* Navigation Arrows */}
            <button className="home-film-carousel-btn home-film-carousel-btn-prev" onClick={prevSlide} aria-label="Previous slide">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M15 18l-6-6 6-6"/>
              </svg>
            </button>
            <button className="home-film-carousel-btn home-film-carousel-btn-next" onClick={nextSlide} aria-label="Next slide">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M9 18l6-6-6-6"/>
              </svg>
            </button>
            
            {/* Indicators */}
            <div className="home-film-carousel-indicators">
              {images.map((_, index) => (
                <button
                  key={index}
                  className={`home-film-carousel-indicator ${index === currentSlide ? 'active' : ''}`}
                  onClick={() => goToSlide(index)}
                  aria-label={`Go to slide ${index + 1}`}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  };

  // Media Planning Section Component
  const MediaPlanningSection = () => {
    const mediaCards = [
      {
        title: 'OTT ADVERTISING',
        description: 'Streaming platform advertising for maximum reach',
        image: '/assets/Media_Planning/ott.jpeg',
        buttonText: 'DIGITAL',
        route: '/digital-marketing'
      },
      {
        title: 'TV ADVERTISING',
        description: 'Traditional television commercials with modern impact',
        image: '/assets/Media_Planning/tv.jpeg',
        buttonText: 'BROADCAST',
        route: '/television'
      },
      {
        title: 'THEATER ADVERTISING',
        description: 'Cinema advertising for captive audiences',
        image: '/assets/Media_Planning/Thertre.jpeg',
        buttonText: 'ENTERTAINMENT',
        route: '/theatre'
      },
      {
        title: 'NEWSPAPER ADVERTISING',
        description: 'Print media advertising for local reach',
        image: '/assets/Media_Planning/toi-img.png',
        buttonText: 'PRINT',
        route: '/print'
      },
      {
        title: 'DIGITAL MEDIA',
        description: 'Social media and digital platform advertising',
        image: '/assets/Media_Planning/whatspic.avif',
        buttonText: 'SOCIAL',
        route: '/digital-marketing'
      }
    ];

    const handleCardNavigate = (route) => {
      navigate(route);
    };

    return (
      <div className="home-media-planning-section">
        <h2 className="home-media-planning-title">Media Planning</h2>
        <div className="home-media-planning-underline"></div>
        <p className="home-media-planning-description">
          Discover the most effective way to connect with your target audience through FILMYADS. We specialize in digital media planning and buying, positioning ourselves as a top OTT and digital media company for promoting your brand and products. As a seasoned ad film production house, we craft high-impact commercials that drive results and elevate your brand presence.
        </p>
        
        <div className="home-media-container">
          <div className="home-media-grid">
            {mediaCards.map((card, index) => (
              <div key={index} className="home-media-col">
                <div className="home-media-card">
                  <div className="home-media-image">
                    <img src={card.image} alt={card.title} className="home-media-icon" />
                  </div>
                  <div className="home-media-content">
                    <h3 className="home-media-title">{card.title}</h3>
                    <p className="home-media-description">{card.description}</p>
                    <button className="home-media-btn" onClick={() => handleCardNavigate(card.route)}>{card.buttonText}</button>
                  </div>
                </div>
              </div>
            ))}
          </div>
          
          <div className="home-know-more-container">
            <button className="home-know-more-btn" onClick={() => navigate('/digital-marketing')}>
              Know More
            </button>
          </div>
        </div>
      </div>
    );
  };

  // Features Section Component
  const FeaturesSection = () => {
    const features = [
      {
        title: 'Creative Excellence',
        description: 'Innovative concepts that captivate audiences',
        image: '/assets/features/creative.jpeg',
        alt: 'Creative solutions and innovative concepts'
      },
      {
        title: 'Timely Delivery',
        description: 'Professional service with guaranteed deadlines',
        image: '/assets/features/time.jpeg',
        alt: 'Timely project delivery and professional service'
      },
      {
        title: 'Cost Effective',
        description: 'Value for money',
        image: '/assets/features/cost.jpeg',
        alt: 'Cost effective solutions for businesses'
      }
    ];

    return (
      <div className="home-features-section">
        <div className="home-features-container">
          <h2 className="home-features-title">Features</h2>
          <div className="home-features-underline"></div>
          
          <div className="home-features-grid">
            {features.map((feature, index) => (
              <div key={index} className="home-feature-item">
                <img 
                  src={feature.image} 
                  alt={feature.alt} 
                  className="home-features-icon" 
                  loading="lazy"
                />
                <h3 className="home-features-heading">{feature.title}</h3>
                <p className="home-features-desc">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  };

  // Choose ARK Section Component
  const ChooseArkSection = () => {
    const [currentSlide, setCurrentSlide] = useState(0);
    
    const images = [
      '/assets/When_to_choose/a-workspace.jpg',
      '/assets/When_to_choose/cameras-at-a-live.jpg',
      '/assets/When_to_choose/film-industry.jpg',
      '/assets/When_to_choose/movie-camera-behind.jpg',
      '/assets/When_to_choose/photo-camera-on-tripod.jpg'
    ];

    useEffect(() => {
      const interval = setInterval(() => {
        setCurrentSlide((prev) => (prev + 1) % images.length);
      }, 5000);

      return () => clearInterval(interval);
    }, [images.length]);

    const nextSlide = () => {
      setCurrentSlide((prev) => (prev + 1) % images.length);
    };

    const prevSlide = () => {
      setCurrentSlide((prev) => (prev === 0 ? images.length - 1 : prev - 1));
    };

    const goToSlide = (index) => {
      setCurrentSlide(index);
    };

    return (
      <div className="home-choose-ark-section">
        <div className="home-choose-ark-container">
          <h2 className="home-choose-ark-title">When to choose ARK Moving Images</h2>
          <div className="home-choose-ark-underline"></div>
          <p className="home-choose-ark-description">
            It's time to emotionally connect your brand with your audience.<br />
            ARK Moving Images is a dynamic ad film company specializing in television ads, theatre commercials, and impactful brand films. We help organizations elevate their marketing efforts by creating compelling content that resonates emotionally and adds a personalized brand touch.<br /><br />
            Recognizing a gap in the industry where few agencies offer high-quality, concept-driven ad films, ARK Moving Images set out to transform the way commercial ads are produced. We focus on building a deep emotional connection with the audience to leave a lasting impression.<br /><br />
            As a leading team of ad filmmakers based in Bangalore, we handle the entire process—from creative concept to final delivery—offering end-to-end ad production, advertising, and marketing communication services. Our mission is to craft powerful visual campaigns that leave a meaningful impact for every brand we work with.
          </p>
          
          <div className="choose-ark-carousel-container">
            <div className="choose-ark-carousel">
              <div className="choose-ark-carousel-track" style={{ transform: `translateX(-${currentSlide * 100}%)` }}>
                {images.map((image, index) => (
                  <div key={index} className={`choose-ark-carousel-slide ${index === currentSlide ? 'active' : ''}`}>
                    <img src={image} alt={`Choose ARK ${index + 1}`} />
                  </div>
                ))}
              </div>
              
              {/* Navigation Arrows */}
              <button className="choose-ark-carousel-btn choose-ark-carousel-btn-prev" onClick={prevSlide} aria-label="Previous slide">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M15 18l-6-6 6-6"/>
                </svg>
              </button>
              <button className="choose-ark-carousel-btn choose-ark-carousel-btn-next" onClick={nextSlide} aria-label="Next slide">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M9 18l6-6-6-6"/>
                </svg>
              </button>
              
              {/* Indicators */}
              <div className="choose-ark-carousel-indicators">
                {images.map((_, index) => (
                  <button
                    key={index}
                    className={`choose-ark-carousel-indicator ${index === currentSlide ? 'active' : ''}`}
                    onClick={() => goToSlide(index)}
                    aria-label={`Go to slide ${index + 1}`}
                  />
                ))}
              </div>
            </div>
          </div>
          
          <div className="about-us-container">
            <button className="about-us-btn" onClick={() => navigate('/about')}>
              About Us
            </button>
          </div>
        </div>
      </div>
    );
  };

  // Process Section Component
  const ProcessSection = () => {
    return (
      <div className="process-section">
        <div className="process-container">
          <div className="process-content">
            <div className="process-left">
              <div className="process-text-content">
                <h2 className="process-title">Our Process</h2>
                <div className="process-underline"></div>
                <p className="process-desc">
                  We produce mind-blowing and creative concept Videos. We produce stunning AD films to build strong brand equity and grabs audience attention for successful ad campaigns.
                </p>
                <button className="process-btn" onClick={() => navigate('/contact')}>
                  Contact Us
                </button>
              </div>
            </div>
            <div className="process-right">
              <img 
                src="/assets/img/process_section/process.jpg" 
                alt="Our creative process illustration" 
                className="process-img" 
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    );
  };

  // Digital Marketing Section Component
  const DigitalMarketingSection = () => {
    const [currentSlide, setCurrentSlide] = useState(0);
    
    const images = [
      {
        src: '/assets/Media_Planning/ott.jpeg',
        alt: 'OTT Ads'
      },
      {
        src: '/assets/Media_Planning/YouTube-ads.webp',
        alt: 'YouTube Ads'
      },
      {
        src: '/assets/Media_Planning/instagramads.webp',
        alt: 'Instagram Ads'
      }
    ];

    useEffect(() => {
      const interval = setInterval(() => {
        setCurrentSlide((prev) => (prev + 1) % images.length);
      }, 5000);

      return () => clearInterval(interval);
    }, [images.length]);

    const nextSlide = () => {
      setCurrentSlide((prev) => (prev + 1) % images.length);
    };

    const prevSlide = () => {
      setCurrentSlide((prev) => (prev === 0 ? images.length - 1 : prev - 1));
    };

    const goToSlide = (index) => {
      setCurrentSlide(index);
    };

    return (
      <div className="digital-marketing-section">
        <div className="dm-container">
          <div className="dm-content">
            <div className="dm-left">
              <div className="dm-carousel-container">
                <div className="dm-carousel">
                  <div className="dm-carousel-track" style={{ transform: `translateX(-${currentSlide * 100}%)` }}>
                    {images.map((image, index) => (
                      <div key={index} className={`dm-carousel-slide ${index === currentSlide ? 'active' : ''}`}>
                        <img src={image.src} alt={image.alt} />
                      </div>
                    ))}
                  </div>
                  
                  {/* Navigation Arrows */}
                  <button className="dm-carousel-btn dm-carousel-btn-prev" onClick={prevSlide} aria-label="Previous slide">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M15 18l-6-6 6-6"/>
                    </svg>
                  </button>
                  <button className="dm-carousel-btn dm-carousel-btn-next" onClick={nextSlide} aria-label="Next slide">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M9 18l6-6-6-6"/>
                    </svg>
                  </button>
                  
                  {/* Indicators */}
                  <div className="dm-carousel-indicators">
                    {images.map((_, index) => (
                      <button
                        key={index}
                        className={`dm-carousel-indicator ${index === currentSlide ? 'active' : ''}`}
                        onClick={() => goToSlide(index)}
                        aria-label={`Go to slide ${index + 1}`}
                      />
                    ))}
                  </div>
                </div>
              </div>
            </div>
            <div className="dm-right">
              <h2 className="dm-title">We Advertise Your Business Digitally</h2>
              <p className="dm-desc">
                ARK Moving Images is dedicated to creating powerful, visually captivating advertisements that connect brands with their audience. We combine cinematic storytelling, high-end production, and innovative visual effects to deliver commercials that leave a lasting impression. Our expertise spans across TV ads, digital campaigns, corporate videos, and promotional content, ensuring every project aligns perfectly with your brand's identity and goals. From script to screen, we focus on crafting ads that not only look stunning but also drive engagement, build trust, and boost business impact. With ARK Moving Images, your brand's story gets the spotlight it deserves.
              </p>
              <button className="dm-btn" onClick={() => navigate('/digital-marketing')}>
                Learn More
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };



  // Main Home Component
  return (
    <div className="home-page-container">
      {/* Fixed Video Background */}
      <FixedVideoBackground />
      
      {/* Scrollable Content */}
      <main className="scrollable-content">
        <HeroSection />
        <ServicesSection />
        <FilmMakingSection />
        <MediaPlanningSection />
        <FeaturesSection />
        <ChooseArkSection />
        <ProcessSection />
        <DigitalMarketingSection />
        <Footer />
      </main>
    </div>
  );
};

export default Home;
